var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootsBenefits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 485,
    height: 515,
    viewBox: "0 0 485 515",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M331.629 336.779C325.039 327.902 321.406 317.213 321.501 306.158C321.502 305.992 321.503 305.826 321.503 305.659C321.503 264.738 278.496 231.565 225.444 231.565C172.392 231.565 129.385 264.738 129.385 305.659C129.385 305.841 129.386 306.023 129.388 306.206C129.491 317.253 125.855 327.934 119.275 336.808C111.872 346.79 107.534 359.183 107.655 372.593C107.943 404.628 134.087 430.872 166.12 431.276C173.84 431.374 181.226 429.994 188.013 427.402C212.175 418.173 238.749 418.173 262.911 427.402C269.697 429.994 277.082 431.373 284.803 431.276C316.843 430.872 342.989 404.618 343.27 372.577C343.387 359.16 339.042 346.763 331.629 336.779Z",
    fill: "#88CCDD",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M204.922 130.446C204.922 102.205 186.768 79.3113 164.373 79.3113C141.979 79.3113 123.824 102.205 123.824 130.446C123.824 158.688 141.979 181.582 164.373 181.582C186.768 181.582 204.922 158.688 204.922 130.446Z",
    fill: "#88CCDD",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.248 242.265C101.248 214.024 83.0939 191.13 60.6993 191.13C38.3048 191.13 20.1504 214.024 20.1504 242.265C20.1504 270.506 38.3048 293.4 60.6993 293.4C83.0939 293.4 101.248 270.506 101.248 242.265Z",
    fill: "#88CCDD",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M332.481 130.46C332.481 102.219 314.326 79.3247 291.932 79.3247C269.537 79.3246 251.383 102.219 251.383 130.46C251.383 158.701 269.537 181.595 291.932 181.595C314.326 181.595 332.481 158.701 332.481 130.46Z",
    fill: "#88CCDD",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M433.507 242.3C433.507 214.059 415.353 191.165 392.958 191.165C370.564 191.165 352.409 214.059 352.409 242.3C352.409 270.541 370.564 293.435 392.958 293.435C415.353 293.435 433.507 270.542 433.507 242.3Z",
    fill: "#88CCDD",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootsBenefits);
export default __webpack_public_path__ + "static/media/foots-benefits.d0170fdbd43755c562c3481809ca87bb.svg";
export { ForwardRef as ReactComponent };